import React from "react";
import Logo from "../../assets/EP_logo_withwords-01.png";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { backgroundColor: "white", fontFamily: "Helvetica" },
  section: {
    color: "black",
    textAlign: "center",
    margin: 30,
    fontFamily: "Helvetica-Bold",
  },

  logoImg: { width: "100px", height: "100px" },
  imageText: { fontSize: 10, fontWeight: 700 },
  flexBox: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  boxInformation: {
    display: "flex",
    flexDirection: "row",
    gap: 5,
    marginBottom: 10,
  },
  tableBox: {
    marginTop: 15,
    backgroundColor: "#F0F0F0",
    display: "flex",
    flexDirection: "row",
    border: "1px solid gray",
    width: "100%",
  },
  tableBoxSecond: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
    borderBottom: "1px solid gray",
  },
  tableThird: {
    display: "flex",
    width: "100%",
    flexDirection: "row-reverse",
    borderLeft: "1px solid white",
    borderRight: "1px solid gray",
    borderBottom: "1px solid white",
  },
  tableFourth: {
    top: "-1px",
    display: "flex",
    width: "100%",
    flexDirection: "row-reverse",
    borderLeft: "1px solid white",
    borderRight: "1px solid gray",
    borderBottom: "1px solid white",
  },
});

const Receipt = (props) => {
  const {
    txId,
    email,
    phoneNumber,
    fullName,
    paymentMethod,
    description,
    date,
    price,
  } = props;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{ margin: 20 }}>
          <Image src={Logo} style={styles.logoImg} />
          <View style={{ width: "120px", marginTop: 10 }}>
            <Text style={styles.imageText}>
              Tai Ho Road, Tsuen Wan, Hong
              Kong
            </Text>
          </View>
        </View>
        <View style={{ margin: 30 }}>
          <View style={styles.section}>
            <Text>Invoice</Text>
          </View>
          <View style={styles.flexBox}>
            <View>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 5,
                }}
              >
                Bill To:
              </Text>
              <Text style={{ fontSize: 10, marginBottom: 2 }}>{fullName}</Text>
              <Text style={{ fontSize: 10, marginBottom: 2 }}>
                {phoneNumber}
              </Text>
              <Text style={{ fontSize: 10 }}>{email}</Text>
            </View>
            <View>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 5,
                }}
              >
                Payee:
              </Text>
              <Text style={{ fontSize: 10, marginBottom: 2 }}>
                Elite Paradise
              </Text>
              <Text style={{ fontSize: 10, marginBottom: 2 }}>
                100 Tai Ho Road.
              </Text>
              <Text style={{ fontSize: 10 }}>Tsuen Wan,Hong Kong</Text>
            </View>
            <View style={{ width: "40%" }}>
              <View style={styles.boxInformation}>
                <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                  Payment Method:
                </Text>
                <Text style={{ fontSize: 10 }}>{paymentMethod}</Text>
              </View>
              <View style={styles.boxInformation}>
                <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                  Transaction ID:
                </Text>
                <Text style={{ fontSize: 10 }}>{txId}</Text>
              </View>
              <View style={styles.boxInformation}>
                <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                  Date:
                </Text>
                <Text style={{ fontSize: 10 }}>{date}</Text>
              </View>
            </View>
          </View>
          <View style={styles.tableBox}>
            <View
              style={{
                padding: 10,
                width: "15%",
                textAlign: "center",
                borderRight: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                QNTY
              </Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "50%",
                textAlign: "center",
                borderRight: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                Description
              </Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "15%",
                textAlign: "center",
                borderRight: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                Unit Price
              </Text>
            </View>
            <View style={{ padding: 10, width: "20%", textAlign: "center" }}>
              <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                Amount
              </Text>
            </View>
          </View>
          <View style={styles.tableBoxSecond}>
            <View
              style={{
                padding: 10,
                width: "15%",
                textAlign: "center",
                borderRight: "1px solid gray",
                // margin: "auto",
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                1
              </Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "50%",
                textAlign: "center",
                borderRight: "1px solid gray",
                // margin: "auto",
              }}
            >
              <Text style={{ fontSize: 10 }}>{description}</Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "15%",
                textAlign: "center",
                borderRight: "1px solid gray",
                // margin: "auto",
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                HK${price}
              </Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "20%",
                textAlign: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                HK${price}
              </Text>
            </View>
          </View>
          <View style={styles.tableThird}>
            <View
              style={{
                padding: 10,
                width: "20%",
                textAlign: "center",
                borderBottom: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 10 }}>HK${price}</Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "15%",
                textAlign: "center",
                borderRight: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 10 }}>Sub-Total</Text>
            </View>
          </View>
          <View style={styles.tableFourth}>
            <View
              style={{
                padding: 10,
                width: "20%",
                textAlign: "center",
                borderBottom: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                HK${price}
              </Text>
            </View>
            <View
              style={{
                padding: 10,
                width: "15%",

                textAlign: "center",
                borderRight: "1px solid gray",
              }}
            >
              <Text style={{ fontSize: 12, fontFamily: "Helvetica-Bold" }}>
                Total
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default Receipt;
